export default __webpack_public_path__ + "static/media/mzo.afb5c8f9.png";